import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface CreateRoomState {
  isCreatingRoom: boolean;
}

const initialState: CreateRoomState = {
  isCreatingRoom: false,
};

export const createRoomSlice = createSlice({
  name: 'createRoom',
  initialState,
  reducers: {
    toggleCreatingRoom: (state, action: PayloadAction<boolean>) => {
      // console.log(`Creating Room State: ${action.payload}`);
      state.isCreatingRoom = action.payload;
    },
  },
});

export const { toggleCreatingRoom } = createRoomSlice.actions;
export const getCreatingRoomState = (state: RootState) =>
  state.createRoom.isCreatingRoom;
export default createRoomSlice.reducer;
